var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"syj_homecenterbet syj_page-width"},[_vm._m(0),_c('div',{ref:"chart2",staticStyle:{"height":"280px"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('title',{staticClass:"commom-title"},[_c('span',[_vm._v("集中投注区间投注数")])])
}]

export { render, staticRenderFns }